import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ISpaceDetails } from '@api/types'
import { SpaceDetailsFragment } from '@api/fragments'

interface IPayload {
  data: {
    node: ISpaceDetails
  }
}

export default function spaceDetails(id: string, apId?: string): Promise<ISpaceDetails> {
  const variables = { id, assignmentPlanId: apId }

  return client.gql.query({ variables, query }).then(({ data: { node } }: IPayload) => node)
}

const query = gql`
  query SpaceDetails($id: ID!, $assignmentPlanId: ID) {
    node(id: $id) {
      ... on Space {
        ...SpaceDetailsFragment
      }
    }
  }
  ${SpaceDetailsFragment}
`
